import React from 'react'

class HeaderSection extends React.Component {
    constructor(props) {
        super(props);
        this.state = { title: props.title, background_pic: props.bg };
    }

    render() {
        return (            
            <div className="uk-margin-large-top">
                <div className="uk-container">
                    <h1 className="uk-heading-divider uk-text-uppercase gradient-headers">{this.state.title}</h1>
                </div>
            </div>
        );
    }
}

export default HeaderSection;